import React from "react";

function Stage5() {
  return (
    <>
    {/* <div className="stylesheetpage-container">
      <div className="stylesheetpage-box"> */}
        <h2 className="stylesheetpage-title">Secondary Key Stage 5 (A Level)</h2>
        <p className="stylesheetpage-text">
          <strong>AS / A Level </strong>
        </p>
        <p className="stylesheetpage-text">
          <strong>Grades 11 &amp; 12</strong>
        </p>
        <p className="stylesheetpage-text">
          ACE follows the Cambridge Advanced Curricula which are typically for
          16-19 year olds. This helps students to develop in-depth
          understanding, independent learning and critical thinking skills which
          universities value highly. It builds on the foundations of Cambridge
          Secondary 2 and leads to entry to universities worldwide. Cambridge
          Advanced includes Cambridge International AS / A Level; both focus on
          equipping students with skills they need to succeed at university
          level, and as such, are recognized by universities and employers
          worldwide. At ACE, Cambridge International AS Level is available for
          students in Grade 11 while Cambridge International A Level is
          available for learners in Grade 12.
        </p>
        <p className="stylesheetpage-text">
          Each subject that a Cambridge international student takes at AS and A
          Level receives a separately certified grade. From 2010, the Cambridge
          International A Level will be reported on a grade – scale from Grade
          A* – E; awarded respectively for the highest level of achievement to
          the minimum required performance. According to Cambridge International
          there is no A* grading in the certification of Cambridge International
          AS Levels.
        </p>
        <p className="stylesheetpage-text">
          ACE is offering Cambridge International AS Level subjects which
          consist of half the content of the corresponding Cambridge
          International A Level; and may be completed in one year. ACE can offer
          Cambridge International AS Level as a qualification in its own right
          or as a stage on the way to Cambridge International A Level. Students
          may study Cambridge International AS Level alongside other subjects to
          increase breadth in the curriculum and build further knowledge and
          understanding to other subjects they are studying at Cambridge
          International A Level.
        </p>
        <p className="stylesheetpage-text">
          The staged assessment route is not possible in all subjects. Cambridge
          International AS Level provides valuable feedback on performance,
          identifying strengths and weakness prior to any final assessment.
          Taking the Cambridge International AS Level examination part-way
          through the Cambridge International A Level course provides feedback
          that learners can use to set learning goals for the second half of the
          course. It can also provide learners with the motivation and momentum
          to complete their programme of study.
        </p>
        <p className="stylesheetpage-text">
          ACE is offering the following subjects at Grade 11 for Cambridge AS
          Level which are carried on to Grade 12 for Cambridge International A
          Level.
        </p>
        <p className="stylesheetpage-text">
          (N.B. As stated before the staged assessment route is not possible in
          all subjects.)
        </p>
        <p className="stylesheetpage-text">
          A selection of minimum THREE (03) subjects is the requirement of both
          national and international Higher Education Institutes – HEIs.
          Students may additionally choose extra subjects if desired
        </p>
        <ul>
          <li>Biology 9700</li>
          <li>Chemistry 9701</li>
          <li>Physics 9702</li>
          <li>Mathematics 9709</li>
          <li>Accounting 9706</li>
          <li>Business Studies 9707</li>
          <li>Economics 9708</li>
          <li>Computing 9691</li>
          <li>Art and Design 9704</li>
          <li>Psychology 9698</li>
        </ul>
        <p className="stylesheetpage-text">&nbsp;</p>
        <p className="stylesheetpage-text">
          <strong>
            Students must choose subjects after consultation with the Head;
            secondary / A Level Section in order to be fully apprised with the
            updated university requirements.{" "}
          </strong>
        </p>
      {/* </div>
    </div> */}
    </>
  );
}

export default Stage5;
